import React from "react";

import "./emotionCard.scss";

interface EmotionCardProps {
  imageSrc: string;
  tituloBanner: string;
  href?: string;
  useDarkMode?: boolean;
  useCheckIcon?: boolean;
  selected?: boolean;
  gtmClass: string;
}

interface ConditionalWrapperProps {
  href: string | null;
  useDarkMode: boolean;
  selected: boolean,
  children: any;
  tituloBanner: String;
  gtmClass: string;
}

const EmotionCard = (props: EmotionCardProps) => {
  const {
    imageSrc,
    tituloBanner,
    href = null,
    useDarkMode = true,
    useCheckIcon = false,
    selected = false,
    gtmClass = ""
  } = props;

  return (
    <>
      <ConditionalWrapper 
        href={href} 
        useDarkMode={useDarkMode}
        selected={selected}
        tituloBanner={tituloBanner}
        gtmClass={gtmClass}
      >
        <>
          {useCheckIcon && (
            <div className="icon-check1 m-emotion-card__icon-check "></div>
          )}
          <img src={imageSrc} alt={tituloBanner} />
          <p className={`m-emotion-card__name`}>{tituloBanner}</p>
        </>
      </ConditionalWrapper>
    </>
  );
};

const ConditionalWrapper = (props: ConditionalWrapperProps) => {
  const { href, useDarkMode, selected, children, gtmClass } = props;
  return href ? (
    <a
      href={href}
      className={`m-emotion-card ${gtmClass} ${
        useDarkMode ? "m-emotion-card-dark-mode" : ""
      } ${selected ? "m-emotion-card--selected" : ""}`}
    >
      {children}
    </a>
  ) : (
    <div
    className={`m-emotion-card ${gtmClass}
      ${useDarkMode ? "m-emotion-card-dark-mode" : ""} 
      ${selected ? "m-emotion-card--selected" : ""}`}
    >
      {children}
    </div>
  );
};

export default EmotionCard;
